
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/braderie",
      function () {
        return require("private-next-pages/[locale]/braderie/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/braderie"])
      });
    }
  